import { render } from "./ylyProjectManage.vue?vue&type=template&id=acee85ec&scoped=true"
import script from "./ylyProjectManage.vue?vue&type=script&lang=js"
export * from "./ylyProjectManage.vue?vue&type=script&lang=js"

import "./ylyProjectManage.vue?vue&type=style&index=0&id=acee85ec&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acee85ec"]])

export default __exports__